<template>
  <div class="home" :style="homeBackgroundStyle">
    <div class="hero">
      <h1>CLUBS &amp; NAs POINTS MANAGEMENT</h1>
    </div>
  </div>
</template>

<script>
import { homeBackgroundStyle } from '@/utils/homeBackground'
export default {
  name: 'HomeView',
  computed: {
    homeBackgroundStyle() {
      return homeBackgroundStyle
    }
  }
}
</script>

<style scoped>
.home {
  width: 100%;
  min-height: calc(100vh - 90px);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero {
  text-align: center;
  padding: 2.5rem 2rem;
  border: 1px solid rgba(255, 255, 255, 0.26);
  border-radius: 14px;
  background: rgba(7, 18, 40, 0.42);
  backdrop-filter: blur(3px);
}

.hero h1 {
  font-size: clamp(1.8rem, 3vw, 2.75rem);
  margin: 0;
  color: #ffffff;
  letter-spacing: 0.03em;
}
</style>
